import { heroEquipment } from "../HeroEquipment";

export const khazadzi = {
  heroes: {
    Tan: {
      id: 0,
      startingEquipment: ["Sztylet", "Topór krasnoludów"],
      cost: 75,
      number: 1,
      equipmentList: heroEquipment["Khazadzi z Gór Krańca Świata"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [3, 5, 4, 4, 4, 2, 3, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Dowodzenie",
        "Dowódca",
        "Krzepki",
        "Nieustępliwy",
        "Odporność na magię (2)",
        "Rankor",
        "Rewelator",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
      ],
      exp: 20,
      skills: [0, 1, 2, 3, 5],
    },
    "Kowal run": {
      id: 1,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 50,
      number: 1,
      equipmentList: heroEquipment["Khazadzi z Gór Krańca Świata"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [3, 4, 4, 3, 4, 1, 2, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: ["Błogosławieństwo Valayi","Kowal Run","Krzepki","Nieustępliwy","Odporność na magię (2)","Rankor","Rozproszenie magii (1)","Trudny do zabicia","Uporczywość","Wspinaczka","Zabobonny lęk"],
      exp: 12,
      skills: [0, 2, 3, 5],
    },
    "Mistrz inżynier": {
      id: 2,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 50,
      number: 1,
      equipmentList: heroEquipment["Khazadzi z Gór Krańca Świata"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [3, 4, 4, 3, 4, 1, 2, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Drużyna obsługi",
        "Inżynier",
        "Krzepki",
        "Mistrz inżynier",
        "Nieustępliwy",
        "Odporność na magię (2)",
        "Rankor",
        "Saper",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
      ],
      exp: 12,
      skills: [0, 1, 2, 3, 5],
    },
    Długobrody: {
      id: 3,
      startingEquipment: ["Sztylet", "Broń wielka"],
      cost: 45,
      number: 1,
      equipmentList: heroEquipment["Khazadzi z Gór Krańca Świata"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [3, 5, 3, 3, 4, 1, 2, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Krzepki",
        "Nieustępliwy",
        "Odporność na magię (2)",
        "Rankor",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
        "Zimnokrwisty",
      ],
      exp: 10,
      skills: [0, 3, 5],
    },
    "Łamacz żelaza": {
      id: 4,
      startingEquipment: ["Sztylet", "Topór krasnoludów"],
      cost: 40,
      number: 1,
      equipmentList: heroEquipment["Khazadzi z Gór Krańca Świata"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [3, 4, 3, 3, 4, 1, 2, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Krzepki",
        "Nieustępliwy",
        "Odporność na magię (2)",
        "Rankor",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
        "Żelazoskóry",
      ],
      exp: 8,
      skills: [0, 3, 5],
    },
    "Wojownik klanowy": {
      id: 5,
      startingEquipment: ["Sztylet"],
      cost: 25,
      number: 12,
      equipmentList: heroEquipment["Khazadzi z Gór Krańca Świata"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [3, 4, 3, 3, 4, 1, 2, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Chorążowie & sygnaliści",
        "Drużyna obsługi",
        "Krzepki",
        "Nieustępliwy",
        "Odporność na magię (2)",
        "Rankor",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
      ],
    },
    Strzelec: {
      id: 6,
      startingEquipment: ["Sztylet"],
      cost: 45,
      number: 5,
      equipmentList: heroEquipment["Khazadzi z Gór Krańca Świata"].Strzelec,
      type: "Stronnik",
      stats: {
        Początkowa: [3, 4, 3, 3, 4, 1, 2, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Błyskawiczne przeładowanie",
        "Krzepki",
        "Nieustępliwy",
        "Odporność na magię (2)",
        "Rankor",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
      ],
    },
    Górnik: {
      id: 7,
      startingEquipment: ["Sztylet", "Broń wielka"],
      cost: 40,
      number: 5,
      equipmentList: heroEquipment["Khazadzi z Gór Krańca Świata"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [3, 4, 3, 3, 4, 1, 2, 1, 9],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Krzepki",
        "Nieustępliwy",
        "Odporność na magię (2)",
        "Rankor",
        "Saper",
        "Światowiec",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
        "Zwiadowca",
      ],
    },
    "Pogromca trolli": {
      id: 8,
      startingEquipment: [
        "Topór krasnoludów",
        "Topór krasnoludów",
        "Broń wielka",
      ],
      cost: 50,
      number: 3,
      equipmentList: heroEquipment["Khazadzi z Gór Krańca Świata"].Pogromca,
      type: "Stronnik",
      stats: {
        Początkowa: [3, 4, 3, 3, 4, 1, 2, 1, 10],
        Maksymalna: [4, 7, 6, 4, 5, 3, 5, 4, 10],
      },
      rules: [
        "Fanatyk",
        "Krzepki",
        "Nieustępliwy",
        "Ochronne tatuaże",
        "Odporność na magię (2)",
        "Pogromca",
        "Rankor",
        "Topory pogromcy",
        "Trudny do zabicia",
        "Uporczywość",
        "Wspinaczka",
        "Zabobonny lęk",
      ],
    },
    Żyrokopter: {
      id: 9,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        "Początkowa": [2,"-","-",4,5,5,"-","-","-"],
        "Maksymalna": [2,"-","-",4,5,5,"-","-","-"]
      },
      rules: [
        "Bombardowanie (płonący atak)",
        "Duży cel",
        "Kusza parowa",
        "Lot",
        "Machina wojenna",
        "Trafienie z uderzenia",
        "Uporczywość",
        "Zawis",
        "Zwiadowca",
      ],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 12,
  name: "Khazadzi z Gór Krańca Świata",
  nature: "Neutralna",
  armyRules: ["Kontakty handlowe (3)", "Reduta", "Zhańbiony"],
  mercenaries: [
    "Goniec",
    "Miotacz ołowiu",
    "Ochroniarz",
    "Ogniomistrz",
    "Poszukiwacz złota",
    "Strażnik dróg",
    "Zwiadowca",
  ],
};
